import LogoFullHorizontal from '../../../../styles/images/logo/full-horizontal.svg';
import FooterLogo2 from '../../../../styles/images/logo/footerlogo2.webp';
import ExpressDelivery from '../../../../styles/images/svg/footer/express-delivery.svg';
import CashOnDelivery from '../../../../styles/images/svg/footer/cash-on-delivery.svg';
import Support from '../../../../styles/images/svg/footer/support.svg';
import DaysReturn from '../../../../styles/images/svg/footer/days-return.svg';
import OriginalProducts from '../../../../styles/images/svg/footer/original-products.svg';
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import CofeeBazzar from '../../../../styles/images/svg/appStores/coffe-bazzar.svg';
import Myket from '../../../../styles/images/svg/appStores/myket.svg';
import SibApp from '../../../../styles/images/svg/appStores/sib-app.svg';
import More from '../../../../styles/images/svg/More.svg';
import Sapra from '../../../../styles/images/png/sapra.webp';
import Rezi from '../../../../styles/images/png/rezi.png';
import Kasbokar from '../../../../styles/images/png/kasbokar.webp';
import Enamad from '../../../../styles/images/png/enamad.jpg';


const FooterBase = (props) => {


    return (

        <footer className="w-full bg-neutral-000 border-complete-t border-n-200 pt-8 mt-12">
			<div className="container-4xl-w mx-auto">
				<div className="px-5">
					<div className="flex justify-between items-center select-none">
						<div className="ml-4" style={{width: '195px', height: '30px', lineHeight: '0'}}>
							<img className="w-full inline-block" src={LogoFullHorizontal} width="195" height="30" alt="digikala - کوچی" title="" style={{objectFit: 'contain'}} />
						</div>
						<button className="relative flex items-center user-select-none styles_btn__Q4MvL text-button-2 styles_btn--medium__4GoNC styles_btn--neutralOutlined__mLWvq styles_btn--black__xj6Mt rounded-medium flex justify-center items-center px-3 sm:px-4 py-1 rounded cursor-pointer">
							<div className="flex items-center justify-center relative grow">
								<span className="text-neutral-400 ml-2">بازگشت به بالا</span>
								<div className="flex">
									<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-low-emphasis)'}}>
										<use xlinkHref="#expandLess"></use>
									</svg>
								</div>
							</div>
						</button>
					</div>
					<div className="mb-8 mt-4 md:mt-3 md:mb-0 flex items-center flex-wrap lg:flex-nowrap text-body-2 text-neutral-700">
						<p className="shrink-0" data-cro-id="footer-phonenumber">تلفن پشتیبانی ۶۱۹۳۰۰۰۰ - ۰۲۱
						</p>
						<div className="px-5 text-neutral-400 hidden md:block">|
						</div>
						<p className="shrink-0">۰۲۱-۹۱۰۰۰۱۰۰
						</p>
						<div className="px-5 text-neutral-400 hidden md:block">|
						</div>
						<p className="w-full mt-1 md:mt-0">۷ روز هفته، ۲۴ ساعته پاسخگوی شما هستیم
						</p>
					</div>
					<div className="flex my-8 items-center justify-between select-none hidden lg:flex">
						<a className="flex py-3 flex-col items-center justify-between text-center grow" data-cro-id="footer-features" href="/faq/question/79/">
							<div style={{width: '56px', height: '56px', lineHeight: '0'}}>
								<img className="w-full inline-block" src={ExpressDelivery} width="56" height="56" alt="اﻣﮑﺎن ﺗﺤﻮﯾﻞ اﮐﺴﭙﺮس" title=""  style={{objectFit: 'cover'}} />
							</div>
							<p className="text-caption text-neutral-700">اﻣﮑﺎن ﺗﺤﻮﯾﻞ اﮐﺴﭙﺮس
							</p>
						</a>
						<a className="flex py-3 flex-col items-center justify-between text-center grow" data-cro-id="footer-features" href="/faq/question/81/">
							<div style={{width: '56px', height: '56px', lineHeight: '0'}}>
								<img className="w-full inline-block" src={CashOnDelivery} width="56" height="56" alt="امکان پرداخت در محل" title="" style={{objectFit: 'cover'}} />
							</div>
							<p className="text-caption text-neutral-700">امکان پرداخت در محل
							</p>
						</a>
						<a className="flex py-3 flex-col items-center justify-between text-center grow" data-cro-id="footer-features" href="/page/contact-us/">
							<div style={{width: '56px', height: '56px', lineHeight: '0'}}>
								<img className="w-full inline-block" src={Support} width="56" height="56" alt="۷ روز ﻫﻔﺘﻪ، ۲۴ ﺳﺎﻋﺘﻪ" title="" style={{objectFit: 'cover'}} />
							</div>
							<p className="text-caption text-neutral-700">۷ روز ﻫﻔﺘﻪ، ۲۴ ﺳﺎﻋﺘﻪ
							</p>
						</a>
						<a className="flex py-3 flex-col items-center justify-between text-center grow" data-cro-id="footer-features" href="/faq/question/83/">
							<div style={{width: '56px', height: '56px', lineHeight: '0'}}>
								<img className="w-full inline-block" src={DaysReturn} width="56" height="56" alt="هفت روز ضمانت بازگشت کالا" title="" style={{objectFit: 'cover'}} />
							</div>
							<p className="text-caption text-neutral-700">هفت روز ضمانت بازگشت کالا
							</p>
						</a>
						<a className="flex py-3 flex-col items-center justify-between text-center grow" data-cro-id="footer-features" href="/faq/question/82/">
							<div style={{width: '56px', height: '56px', lineHeight: '0'}}>
								<img className="w-full inline-block" src={OriginalProducts} width="56" height="56" alt="ﺿﻤﺎﻧﺖ اﺻﻞ ﺑﻮدن ﮐﺎﻟﺎ" title="" style={{objectFit: 'cover'}} />
							</div>
							<p className="text-caption text-neutral-700">ﺿﻤﺎﻧﺖ اﺻﻞ ﺑﻮدن ﮐﺎﻟﺎ
							</p>
						</a>
					</div>
					<div className="flex flex-wrap w-full justify-between mb-8">
						<div className="block lg:grow w-6/12 lg:w-unset">
							<p className="text-neutral-700 text-h5 mb-2 block">با کوچی
							</p>
							<a className="text-body-1 text-neutral-500 mb-2 block" data-cro-id="footer-with-digikala" href="https://about.digikala.com/newsroom/">اتاق خبر کوچی
							</a>
							<a className="text-body-1 text-neutral-500 mb-2 block" data-cro-id="footer-with-digikala" href="/landings/seller-introduction/">فروش در کوچی
							</a>
							<a className="text-body-1 text-neutral-500 mb-2 block" data-cro-id="footer-with-digikala" href="https://careers.digikala.com/">فرصت‌های شغلی
							</a>
							<a className="text-body-1 text-neutral-500 mb-2 block" data-cro-id="footer-with-digikala" href="https://digikalapublic.whistleblowernetwork.net/frontpage">گزارش تخلف در کوچی
							</a>
							<a className="text-body-1 text-neutral-500 mb-2 block" data-cro-id="footer-with-digikala" href="/page/contact-us/">تماس با کوچی
							</a>
							<a className="text-body-1 text-neutral-500 mb-2 block" data-cro-id="footer-with-digikala" href="https://about.digikala.com/">درباره کوچی
							</a>
						</div>
						<div className="block lg:grow w-6/12 lg:w-unset">
							<p className="text-neutral-700 text-h5 mb-2 block">خدمات مشتریان
							</p>
							<a className="text-body-1 text-neutral-500 mb-2 block" data-cro-id="footer-customer-service" href="/faq/">پاسخ به پرسش‌های متداول
							</a>
							<a className="text-body-1 text-neutral-500 mb-2 block" data-cro-id="footer-customer-service" href="/faq/question/83/">رویه‌های بازگرداندن کالا
							</a>
							<a className="text-body-1 text-neutral-500 mb-2 block" data-cro-id="footer-customer-service" href="/page/terms/">شرایط استفاده
							</a>
							<a className="text-body-1 text-neutral-500 mb-2 block" data-cro-id="footer-customer-service" href="/page/privacy/">حریم خصوصی
							</a>
							<a className="text-body-1 text-neutral-500 mb-2 block" data-cro-id="footer-customer-service" href="/page/bug-report/">گزارش باگ
							</a>
						</div>
						<div className="block lg:grow w-6/12 lg:w-unset hidden md:block">
							<p className="text-neutral-700 text-h5 mb-2 block">راهنمای خرید از کوچی
							</p>
							<a className="text-body-1 text-neutral-500 mb-2 block" data-cro-id="footer-buying-guide" href="/faq/question/649/">نحوه ثبت سفارش
							</a>
							<a className="text-body-1 text-neutral-500 mb-2 block" data-cro-id="footer-buying-guide" href="/faq/question/79/">رویه ارسال سفارش
							</a>
							<a className="text-body-1 text-neutral-500 mb-2 block" data-cro-id="footer-buying-guide" href="/faq/question/81/">شیوه‌های پرداخت
							</a>
						</div>
						<div className="w-full lg:w-unset shrink-0">
							<div className="w-full flex lg:block lg:flex-row justify-between items-start mt-8 sm:mt-0"><h4 className="mb-3 text-h5 text-neutral-700">همراه ما باشید!</h4>
								<div className="flex items-center">
									<a className="ml-6 lg:ml-8" data-cro-id="footer-instagram" href="https://www.instagram.com/digikalacom/">
										<div className="flex">
											<svg style={{width: '40px', height: '40px', fill: 'var(--color-icon-low-emphasis)'}}>
												<use xlinkHref="#instagram"></use>
											</svg>
										</div>
									</a>
									<a className="ml-6 lg:ml-8" data-cro-id="footer-twitter" href="https://twitter.com/digikalacom">
										<div className="flex">
											<svg style={{width: '40px', height: '40px', fill: 'var(--color-icon-low-emphasis)'}}>
												<use xlinkHref="#twitter"></use>
											</svg>
										</div>
									</a>
									<a className="ml-6 lg:ml-8" data-cro-id="footer-linkedin" href="https://www.linkedin.com/company/digikala/mycompany/">
										<div className="flex">
											<svg style={{width: '40px', height: '40px', fill: 'var(--color-icon-low-emphasis)'}}>
												<use xlinkHref="#linkedin"></use>
											</svg>
										</div>
									</a>
									<a className="" data-cro-id="footer-aparat" href="https://www.aparat.com/digikala/">
										<div className="flex">
											<svg style={{width: '40px', height: '40px', fill: 'var(--color-icon-low-emphasis)'}}>
												<use xlinkHref="#aparat"></use>
											</svg>
										</div>
									</a>
								</div>
							</div>
							<div className="w-full flex flex-col items-start mt-4 sm:mt-8"><h4 className="hidden md:block text-h5 text-neutral-700 mb-3">با ثبت ایمیل، از جدید‌ترین تخفیف‌ها با‌خبر شوید</h4>
								<div className="w-full flex items-center">
									<form className="w-full flex">
										<label className="FormComponentFrame_FormComponentFrame__PIUpy grow w-full">
											<div className="FormComponentFrame_FormComponentFrame__input-container__BHc4I px-2 flex items-center bg-neutral-100 rounded-medium">
												<div className="grow text-body-3">
													<input className="px-2 TextField_TextField__input__hFMFl text-subtitle w-full TextField_TextField__bwN9_ TextField_TextField--primary__IZ6Ku" type="email" name="email" placeholder="ایمیل شما" value="" />
												</div>
											</div>
										</label>
										<button className="relative flex items-center user-select-none styles_btn__Q4MvL text-button-1 styles_btn--large__1Muai styles_btn--primary__y0GEv styles_btn--disabled__lljQT rounded-medium pointer-events-none rounded text-neutral-000 mr-2" type="submit" data-cro-id="footer-email-submission">
											<div className="flex items-center justify-center relative grow">ثبت
											</div>
										</button>
									</form>
								</div>
							</div>
						</div>
					</div>
					<div className="flex flex-col lg:flex-row mb-7 lg:px-5 rounded text-neutral-000 select-none py-2 items-center justify-between BaseLayoutStaticFooter_BaseLayoutStaticFooter__appSection__CH3bo">
						<div className="flex items-center text-white mb-4 lg:mb-0">
							<div className="shrink-0" style={{width: '44px', height: '44px', lineHeight: '0'}}>
								<picture>
									<source type="image/webp" srcset={FooterLogo2} />
									<source type="image/jpeg" srcset={FooterLogo2} />
									<img className="w-full inline-block" src={FooterLogo2} width="44" height="44" alt="کوچی" title="" style={{objectFit: 'cover'}} />
								</picture>
							</div>
							<div className="text-h3 shrink-0 mr-4"> دانلود اپلیکیشن کوچی
							</div>
						</div>
						<div className="flex items-center justify-end grow">
							<div className="flex items-center justify-center lg:justify-end flex-wrap lg:grow">
								<a className="BaseLayoutStaticFooter_BaseLayoutStaticFooter__appDownloadLink__VZlyq m-2" data-cro-id="footer-bazar" target="_blank" title="دریافت از کافه‌بازار" href="https://click.adtrace.io/d5wyajq">
									<div style={{height: '44px', borderRadius: '4px', lineHeight: '0'}}>
										<img className="w-full inline-block" src={CofeeBazzar} height="44" alt="دریافت از کافه‌بازار" title="" style={{objectFit: 'contain', borderRadius: '4px'}} />
									</div>
								</a>
								<a className="BaseLayoutStaticFooter_BaseLayoutStaticFooter__appDownloadLink__VZlyq m-2" data-cro-id="footer-myket" target="_blank" title="دریافت از مایکت" href="https://click.adtrace.io/y9sit74">
									<div style={{height: '44px', borderRadius: '4px', lineHeight: '0'}}>
										<img className="w-full inline-block" src={Myket} height="44" alt="دریافت از مایکت" title="" style={{objectFit: 'contain', borderRadius: '4px'}} />
									</div>
								</a>
								<a className="BaseLayoutStaticFooter_BaseLayoutStaticFooter__appDownloadLink__VZlyq m-2" data-cro-id="footer-sibapp" target="_blank" title="دریافت از سیب‌اپ" href="https://click.adtrace.io/56hqs7k">
									<div style={{height: '44px', borderRadius: '4px', lineHeight: '0'}}>
										<img className="w-full inline-block" src={SibApp} height="44" alt="دریافت از سیب‌اپ" title="" style={{objectFit: 'contain', borderRadius: '4px'}} />
									</div>
								</a>
							</div>
							<a className="hidden lg:block mr-4" data-cro-id="footer-app-landing" target="_blank" href="/landings/new-app/">
								<div className="border-complete-200 bg-neutral-000" style={{width: '44px', height: '44px', borderRadius: '4px', lineHeight: '0'}}>
									<img className="w-full inline-block" src={More} width="44" height="44" alt="" title="" style={{objectFit: 'cover', borderRadius: '4px'}} />
								</div>
							</a>
						</div>
						<a className="inline-flex items-center cursor-pointer styles_Anchor--white__KFujY text-button-2 lg:hidden mt-1" href="/landings/new-app/"><span>اطلاعات بیشتر</span>
							<div className="flex">
								<ChevronLeftIcon sx={{width: '18px', height: '18px', fill: 'var(--color-icon-white)'}} />
							</div>
						</a>
					</div>
					<div className="flex items-start justify-between border-complete-t py-8 border-n-200 flex-wrap lg:flex-nowrap">
						<div className="grow">
							<div className="relative seo lg:ml-10 ml-0 text-neutral-500 text-body-2 overflow-hidden styles_BaseLayoutStaticFooterAboutUs__content__d9jew"><h1>کوچی؛ بزرگترین فروشگاه اینترنتی ایران</h1>

								<p>کوچی سال‌ها است که به انتخاب اول بسیاری از خریداران اینترنتی تبدیل شده است. کوچی به عنوان بزرگ‌ترین و معتبرترین فروشگاه آنلاین ایران، شناخته‌شده‌ترین فروشگاه نیز محسوب می‌شود. این فروشگاه آنلاین نه‌تنها گسترده‌ترین تنوع کالا را در دسته‌بندی‌های مختلف ارائه می‌دهد، بلکه با خدمات بی‌نظیر، سرعت ارسال بالا، ضمانت اصل بودن کالا و پشتیبانی حرفه‌ای، استاندارد جدیدی در خرید اینترنتی ایران تعریف کرده است. این فروشگاه با سال‌ها تجربه و اعتماد مشتریان، کامل‌ترین و بهترین گزینه برای خرید آنلاین در ایران محسوب می‌شود.
								</p>

								<h2>ویژگی های مهم کوچی</h2>

								<p>یکی از ویژگی‌های مهم در خرید از کوچی، تنوع بی‌نظیر محصولات است. این فروشگاه اینترنتی طیف وسیعی از کالاها را در دسته‌های مختلف از جمله لوازم دیجیتال، لوازم خانگی، مد و پوشاک، لوازم آرایشی و بهداشتی، محصولات سلامت و زیبایی، و بسیاری از محصولات دیگر ارائه می‌دهد. به عنوان مثال، اگر به دنبال خرید یک 
									<a href="https://www.digikala.com/search/category-mobile-phone/">گوشی موبایل
									</a> جدید باشید، کوچی مجموعه‌ای از بهترین گوشی‌ها از برندهای معتبر اپل و سامسونگ مانند ایفون 16، 
									<a href="https://www.digikala.com/tags/samsung-s25/">گوشی S25
									</a>، گوشی‌های مختلف از برند شیائومی مانند 
									<a href="https://www.digikala.com/product/dkp-17580036/%DA%AF%D9%88%D8%B4%DB%8C-%D9%85%D9%88%D8%A8%D8%A7%DB%8C%D9%84-%D8%B4%DB%8C%D8%A7%D8%A6%D9%88%D9%85%DB%8C-%D9%85%D8%AF%D9%84-redmi-note-14-4g-%D8%AF%D9%88-%D8%B3%DB%8C%D9%85-%DA%A9%D8%A7%D8%B1%D8%AA-%D8%B8%D8%B1%D9%81%DB%8C%D8%AA-256-%DA%AF%DB%8C%DA%AF%D8%A7%D8%A8%D8%A7%DB%8C%D8%AA-%D9%88-%D8%B1%D9%85-8-%DA%AF%DB%8C%DA%AF%D8%A7%D8%A8%D8%A7%DB%8C%D8%AA">شیائومی نوت ۱۴
									</a> و بسیاری از برندهای دیگر را در اختیار شما قرار می‌دهد. همچنین برای علاقه‌مندان به لوازم دیجیتال، این فروشگاه اینترنتی انواع لپ تاپ، 
									<a href="https://www.digikala.com/search/category-tv2/">تلویزیون
									</a>، 
									<a href="https://www.digikala.com/search/category-speaker/">اسپیکر
									</a>، و هندزفری بلوتوثی با کیفیت بالا را برای خرید آنلاین ارائه می‌دهد. کوچی، مقصدی بی‌پایان برای خرید آسان، سریع و مطمئن است. راهی که هر آنچه نیاز دارید از 
									<a href="https://www.digikala.com/search/category-notebook-netbook-ultrabook/">قیمت لپ تاپ
									</a> تا یک ایرپاد مطمئن را در اختیار شما قرار می‌دهد.&nbsp;
								</p>

								<h3>ارسال سریع و مطمئن کالا</h3>

								<p>یکی از مهم‌ترین دغدغه‌های کاربران خرید آنلاین، زمان تحویل کالا است. کوچی برای حل این مشکل، گزینه‌های مختلف ارسال را در نظر گرفته است تا کاربران بتوانند بر اساس نیاز خود، روش ارسال مناسب را انتخاب کنند. به عنوان مثال، ارسال کالا به صورت ارسال امروز، ارسال سریع توسط پیک‌های کوچی، از جمله روش‌های خرید سریع از این فروشگاه اینترنتی است. این امکانات باعث می‌شود که خریداران بتوانند سفارش خود را در کوتاه‌ترین زمان ممکن دریافت کنند. علاوه بر این، در صورتی که کالای خریداری شده از لحاظ کیفیت یا هر دلیل دیگری رضایت مشتری را جلب نکرده باشد، کوچی ضمانت بازگشت کالا را ارائه می‌دهد. این ویژگی موجب اعتماد بیشتر مشتریان به خرید آنلاین از فروشگاه اینترنتی کوچی شده است.
								</p>

								<h3>تخفیف های ویژه و جشنواره ها</h3>

								<p>کوچی به طور منظم جشنواره‌ها و تخفیف‌های ویژه‌ای را برگزار می‌کند که برای مشتریان فرصت خرید کالاهای باکیفیت با قیمت‌های مناسب به همراه خواهد داشت. این تخفیف‌ها در ایام خاص مانند بلک فرایدی یا همان حراج جمعه سیاه و جشنواره‌های تابستانی توجه بسیاری از خریداران را جلب می‌کند. در این جشنواره‌ها، کوچی تخفیف‌های عالی روی محصولات مختلف از جمله گوشی‌های موبایل، لپ تاپ‌ها، تلویزیون‌ها، و حتی محصولات زیبایی ارائه می‌دهد. می‌توانید 
									<a href="https://www.digikala.com/tags/iphone-16/">گوشی ایفون 16
									</a> یا گوشی S25 را با تخفیف‌های ویژه خریداری کنید و از قیمت مناسب بهره‌مند شوید. کوچی فراتر از یک فروشگاه اینترنتی، یک تجربه خرید مطمئن در بین کاربران مختلف بوده است که با ارائه بزرگ‌ترین تنوع کالا، قیمت‌های مختلف و خدماتی بی‌نقص، به مقصد اول خریداران آنلاین در ایران تبدیل شده است.
								</p>

								<h2>انواع محصولات فروشگاه کوچی</h2>

								<p>کوچی دارای محصولات متنوعی در گروه‌های مختلف است که خرید آنها بسیار راحت و سریع است. به عنوان مثال، اگر به دنبال 
									<a href="https://www.digikala.com/search/category-cell-phone-pouch-cover/">قاب گوشی
									</a> یا 
									<a href="https://www.digikala.com/search/category-headphone/">هندزفری بلوتوثی
									</a> باشید، می‌توانید مدل‌های مختلف و برندهای گوناگونی را در این فروشگاه پیدا کنید.&nbsp;
								</p>

								<h3>موبایل و کالای دیجیتال</h3>

								<p>کوچی انواع گوشی‌های هوشمند از برندهای معتبر جهانی مانند سامسونگ، اپل، شیائومی و هواوی را با مشخصات و قیمت‌های متنوع عرضه می‌کند. علاوه بر موبایل، کوچی مجموعه‌ای از لوازم جانبی مانند هدفون، هندزفری، ساعت‌های هوشمند، تبلت‌ها و لپ تاپ را نیز در اختیار مشتریان قرار می‌دهد. با امکان مقایسه محصولات، مطالعه نظرات کاربران و دسترسی به جدیدترین مدل‌ها، کوچی به یکی از مقاصد اصلی خرید آنلاین در حوزه موبایل و کالای دیجیتال تبدیل شده است. از دهه گذشته همواره کوچی به عنوان اولین گزینه برای 
									<a href="https://www.digikala.com/search/category-mobile-phone/samsung/">خرید گوشی های سامسونگ
									</a>، 
									<a href="https://www.digikala.com/search/category-mobile-phone/apple/">آیفون های اپل
									</a> و 
									<a href="https://www.digikala.com/search/category-mobile-phone/xiaomi/">گوشی شیائومی
									</a> محسوب می‌شده است و تا امروز هم در عرضه این موبایل های محبوب به بازار، کوچی اولین فروشگاه آنلاین بوده است.&nbsp;
								</p>

								<h3>کتاب و لوازم تحریر</h3>

								<p>کتاب، لوازم تحریر و هنر در کوچی یک مجموعه بی‌نظیر از محصولات فرهنگی و هنری است که به علاقه‌مندان به کتابخوانی، هنر و نوشتن کمک می‌کند تا دنیای خود را گسترش دهند. از کتاب‌های چاپی و کتاب‌های صوتی گرفته تا مجلات خارجی و داخلی و آثار معروف‌ترین نویسندگان مثل سعدی، حافظ، مولانا و فروغ فرخزاد، تمامی نیازهای کتابخوان‌ها را پوشش می‌دهد. همچنین با مجموعه‌ای از لوازم تحریر، ابزار نقاشی و رنگ‌آمیزی، آلبوم‌های عکس و فرش‌های دستبافت، به شما این امکان را می‌دهد تا دنیای هنر و خلاقیت خود را به بهترین نحو پرورش دهید.
								</p>

								<h3>لوازم آرایشی و بهداشتی</h3>

								<p>در دسته محصولات آرایشی و بهداشتی، کوچی مجموعه‌ای از بهترین و پرطرفدارترین برندهای جهانی را در اختیار کاربران قرار می‌دهد. محصولات متنوعی همچون 
									<a href="https://www.digikala.com/search/category-moisturizing-cream/">مرطوب كننده‌ها
									</a>، 
									<a href="https://www.digikala.com/search/category-foundation/">كرم پودر
									</a>، 
									<a href="https://www.digikala.com/search/category-sunscreen-cream/">ضدآفتاب
									</a>، ريمل و 
									<a href="https://www.digikala.com/search/category-lipstick/">رژلب
									</a> از برندهایی مانند لورال، کلینیک و میبلین در کوچی موجود هستند که برای هر سلیقه و نیاز قابل انتخاب هستند. علاوه بر این، شما می‌توانید محصولات مراقبت از پوست و مو مانند شامپو، کرم‌های ضد چروک و ماسک صورت را در این فروشگاه بیابید و خرید آنلاین خود را به راحتی انجام دهید. کوچی، بزرگ‌ترین و معتبرترین فروشگاه آنلاین لوازم آرایشی ایران، جایی که تنوع، کیفیت و اطمینان در خرید یکجا جمع شده‌اند.
								</p>

								<h3>خرید آنلاین طلا و جواهرات</h3>

								<p>کوچی به عنوان بزرگترین فروشگاه اینترنتی ایران، یکی از بهترین گزینه‌ها برای خرید طلا و جواهرات آنلاین است. شما می‌توانید 
									<a href="https://www.digikala.com/search/category-women-gold-necklace/">خريد گردنبند طلا
									</a>، انگشتر طلا، گوشواره زنانه طلا و 
									<a href="https://www.digikala.com/search/category-women-gold-bracelet/">دستبند طلا
									</a> را با بهترین قیمت‌ها از کوچی انجام دهید. این فروشگاه مجموعه‌ای از بهترین برندهای طلا و جواهرات را در اختیار مشتریان قرار داده است که انتخاب خرید را برای آنها بسیار آسان می‌کند. همچنین می‌توانید 
									<a href="https://www.digikala.com/search/category-gold-coin/">خريد سكه
									</a>، و حتی 
									<a href="https://www.digikala.com/search/facet/category-gold-coin/coin-type-quarter-coin/">ربع سكه
									</a> را نیز از این فروشگاه با راحت‌ترین روش انجام دهید.&nbsp;
								</p>

								<h3>اسباب بازی</h3>

								<p>این قسمت شامل تمامی نیازهای ضروری برای مراقبت، بهداشت، سرگرمی و راحتی کودک از بدو تولد تا دوران کودکی است. از لوازم بهداشت و حمام کودک و نوزاد مانند پوشک، دستمال مرطوب، شامپو کودک، حوله و وان حمام نوزاد گرفته تا محصولات ویژه‌ای مثل مینی واش و شامپو کودک و نوزاد، همه در این مجموعه موجود هستند. همچنین برای راحتی بیشتر، انواع پوشاک و کفش کودک و نوزاد از لباس نوزادی تا کفش پسرانه، کوله پشتی پسرانه، لباس دخترانه و کفش دخترانه به صورت آنلاین در دسترس شما قرار دارند.
								</p>

								<p>کودکان به سرگرمی‌های ویژه نیاز دارند، از همین رو کوچی مجموعه‌ای کامل از اسباب بازی‌ها از جمله پازل‌ها، لگو و ساختنی‌ها، عروسک‌ها، فیگورها و اسپینر‌ها را به شما ارائه می‌دهد.
								</p>

								<h3>لوازم خانگی و مبلمان</h3>

								<p>در دسته‌بندی لوازم خانگی، کوچی محصولات متنوعی را ارائه می‌دهد که برای راحتی و زیبایی خانه و آشپزخانه شما طراحی شده‌اند. از جمله 
									<a href="https://www.digikala.com/tags/sofa/">مبل راحتی
									</a>، سرویس‌های خواب، آینه‌های دکوراتیو، و ظروف آشپزخانه که همگی از برندهای معتبر و با کیفیت تولید شده‌اند. شما می‌توانید 
									<a href="https://www.digikala.com/search/category-pots-pans/">قابلمه و تابه
									</a>، یخچال، ماشین لباسشویی و بسیاری از لوازم خانگی دیگر را از کوچی خریداری کنید.
								</p>

								<p>مبل‌های راحتی یکی از پرطرفدارترین محصولات خانگی در کوچی هستند. این 
									<a href="https://www.digikala.com/search/category-sofa/">مبل‌ها
									</a> در انواع طرح‌ها و رنگ‌ها و از برندهای معتبر ساخته شده‌اند که با هر دکوراسیونی هماهنگ می‌شوند. همچنین در کوچی&nbsp; انواع 
									<a href="https://www.digikala.com/search/category-bed/">سرویس خواب
									</a> با کیفیت بالا و طراحی روز دنیا در دسترس است. علاوه بر این، اگر به دنبال 
									<a href="https://www.digikala.com/search/category-decorative-mirror/">آینه دکوراتیو
									</a> یا سایر لوازم تزئینی منزل هستید، این فروشگاه بهترین انتخاب‌ها را به شما ارائه می‌دهد.
								</p>

								<h3>سوپرمارکت کوچی</h3>

								<p>در دسته‌بندی خوراکی‌ها و کالاهای اساسی کوچی، شما می‌توانید انواع محصولات ضروری و پرمصرف روزانه خود را پیدا کنید. از شیرینی و آجیل تا نان تازه و نبات خوشمزه گرفته و رب گوجه، ماکارونی، قند، رب انار، برنج و شکر و حتی شیر و 
									<a href="https://www.digikala.com/search/category-dairy/">لبنیات
									</a> همه این محصولات با بالاترین کیفیت و از برندهای معتبر در دسترس شما قرار دارند. این مجموعه شامل همه آن چیزی است که برای تهیه یک وعده غذایی کامل و سالم به آن نیاز دارید. خرید از 
									<a href="https://www.digikala.com/main/food-beverage/">سوپر مارکت آنلاین
									</a>&nbsp; کمک می‌کند که به راحتی و در کمترین زمان ممکن، مواد اولیه مورد نیاز خود را با قیمت‌های مناسب و با تضمین کیفیت دریافت کنید.
								</p>

								<h3>محصولات بومی و محلی</h3>

								<p>در این بخش از کوچی، از برنج، روغن، عسل طبیعی، حلوا شکری، ارده و کنجد سنتی گرفته تا کیک و شیرینی خانگی، لواشک، برگه و آلوچه خانگی، محصولات اصیل و با کیفیت ارائه می‌شود. همچنین، انواع لبنیات سنتی، کره گیاهی و حیوانی محلی، خرمای محلی و خشکبار و آجیل سنتی به همراه غلات و حبوبات ارگانیک، ادویه‌ها و چاشنی‌های ارگانیک نظیر زعفران و زرشک ارگانیک از دیگر گزینه‌های این دسته هستند. برای علاقه‌مندان به دکوراسیون سنتی نیز، محصولاتی مانند لوستر دست ساز، مجسمه‌های سنتی، گلدان و تابلو سنتی، کاشی و آینه سنتی و ظروف آشپزخانه دست ساز از جنس سنتی وجود دارد که خانه شما را به محیطی گرم و اصیل تبدیل خواهد کرد.
								</p>

								<h3>ابزار آلات و تجهیزات</h3>

								<p>این بخش شامل ابزار برقی و غیر برقی در کوچی مجموعه‌ای کامل از ابزارهای مورد نیاز برای پروژه‌های صنعتی، تعمیرات و ساخت می‌شود. از ابزارهای برقی مانند دریل، پیچ گوشتی، فرز، سنگ رومیزی، موتور برق و مکنده-دمنده گرفته تا ابزارهای غیر برقی مثل ابزار دستی، نردبان، اره و مجموعه ابزار، این دسته برای هر نیازی ابزار مناسب را ارائه می‌دهد. همچنین کمپرسور هوا، دستگاه جوش، هویه و ابزار برش و تراشکاری برای انجام کارهای دقیق صنعتی موجود است. به‌علاوه انواع لوازم روانکاری، چسب صنعتی، پیچ و مهره، ماسک تنفسی، لوازم ایمنی و کار و شیرآلات به تکمیل نیازهای شما برای کارهای ساختمانی و صنعتی کمک می‌کند. کوچی یک راهکار کامل برای پروژه‌های حرفه‌ای و خانگی است.
								</p>

								<h3>پوشاک</h3>

								<p>&nbsp;از لباس‌های مردانه شامل هودی، سویشرت، ژاکت، پیراهن، شلوار جین، پالتو، کاپشن، کفش و اکسسوری تا پوشاک زنانه نظیر مانتو، بلوز، تیشرت، لباس مجلسی، لباس خواب، کاپشن و کفش زنانه، همگی در این دسته‌بندی موجود هستند. همچنین برای بچگانه‌ها، از لباس‌های راحتی و خواب، پوشاک ورزشی تا کفش و صندل بچگانه، به‌راحتی می‌توانید کالای مناسب را پیدا کنید. این بخش شامل برندهای معتبر مانند هامتو، چرم مشهد، اسمارا، کروم، گردیه و چرم عطارد است که پوشاک با کیفیت بالا را ارائه می‌دهند. 
									<a href="https://www.digikala.com/landing/apparel/">خرید آنلاین لباس
									</a> از کوچی فرصتی برای همه فروشنده های شناخته شده کشور فراهم کرده است تا فروش اینترنتی بیشتری را تجربه کنند. همچنین شما کاربران می‌توانید طیف وسیعی از پوشاک را به راحتی و از طریق پروفایل همیشگی خود در Digikala خریداری کنید.&nbsp;
								</p>

								<h3>تجهیزات پزشکی و سلامت</h3>

								<p>در این بخش از تجهیزات پزشکی مانند فشارسنج، ترازو، تب سنج و دماسنج گرفته تا دستگاه‌های تنفسی و تجهیزات حرفه‌ای پزشکی، موجود هستند. برای کنترل بیماری‌هایی مانند دیابت و سرماخوردگی، محصولات مناسبی از جمله کیسه نمک، رطوبت‌گیر، و دستگاه‌های تب سنج ارائه می‌شود. علاوه بر این، ماساژور و پد و کیسه آب گرم به شما کمک می‌کنند تا در خانه از تسکین درد و آرامش بیشتری برخوردار شوید.
								</p>

								<h3>محصولات ورزشی و سفر</h3>

								<p>کوچی همچنین برای علاقه‌مندان به ورزش و سفر، محصولات متنوعی را در دسته‌بندی‌های مختلف ارائه می‌دهد. اگر به دنبال خرید وسایل ورزشی برای بدنسازی، ورزش‌های هوازی، یا کمپینگ هستید، کوچی مجموعه‌ای از لوازم ورزشی از جمله وزنه، ساک ورزشی، قمقمه و بسیاری از لوازم دیگر را ارائه می‌دهد. همچنین شما می‌توانید برای سفرهای خود، ساک‌های مسافرتی، کوله پشتی‌های کوهنوردی و لوازم کمپینگ را از این فروشگاه خریداری کنید.
								</p>

								<h3>کارت هدیه</h3>

								<p>کارت هدیه‌ها راهی عالی برای هدیه دادن به عزیزانتان هستند و در کوچی انواع مختلفی از آنها برای مناسبت‌های گوناگون وجود دارد. شما می‌توانید کارت هدیه فیزیکی کوچی را به صورت عمومی یا براساس مناسبت‌های خاص همچون تولد یا سالگرد خریداری کنید. همچنین، کارت هدیه براساس قیمت امکان انتخاب هدیه‌ای مناسب با بودجه شما را فراهم می‌کند. علاوه بر کارت‌های فیزیکی، کارت هدیه الکترونیکی کوچی هم برای افرادی که به دنبال یک گزینه سریع و آسان هستند، وجود دارد.
								</p>

								<h3>مکمل های غذایی</h3>

								<p>کوچی همچنین به عنوان یکی از مراجع معتبر برای خرید 
									<a href="https://www.digikala.com/search/category-sports-and_fitness-supplements/">مکمل
									</a> نیز شناخته می‌شود. شما می‌توانید انواع قرص‌های ویتامین، 
									<a href="https://www.digikala.com/search/facet/category-medical-supplement/type-of-vitamins-and-minerals-magnesium/">منيزيم
									</a>، 
									<a href="https://www.digikala.com/search/facet/category-medical-supplement/type-of-vitamins-and-minerals-zink/">زينك
									</a>، ويتامين C و بسیاری از مکمل‌های دیگر را از برندهای معروف و معتبر در کوچی پیدا کنید. این مکمل‌ها به سلامت شما کمک می‌کنند و برای تقویت سیستم ایمنی بدن یا افزایش انرژی و بهبود وضعیت پوست و مو مفید هستند.
								</p>

								<h3>خرید کالاهای کارکرده</h3>

								<p>
									<a href="https://www.digikala.com/main/used-products/">خرید کالاهای کارکرده
									</a> از کوچی فرصتی عالی برای دسترسی به محصولات با کیفیت و قیمت مناسب است. تمامی کالاهای این دسته‌بندی در وضعیت مشابه‌نو قرار دارند و از نظر فنی و ظاهری کاملا سالم و بدون نقص هستند. همچنین هر کالای کارکرده‌ای که خریداری می‌کنید، دارای 7 روز مهلت تست و ضمانت اصالت است تا شما با خیال راحت از خرید خود اطمینان حاصل کنید. برای گوشی‌های موبایل کارکرده، این فروشگاه 3 ماه گارانتی کوچی سرویس نیز ارائه می‌دهد. از جمله کالاهای کارکرده‌ای که می‌توانید در این دسته پیدا کنید می‌توان به گوشی موبایل کارکرده، لپ تاپ کارکرده، کنسول خانگی کارکرده و ساعت هوشمند کارکرده اشاره کرد. این محصولات با قیمت‌های به‌صرفه، گزینه‌ای مناسب برای کسانی است که به دنبال خرید کالاهای با کیفیت و در عین حال اقتصادی هستند.
								</p>

								<p>در آخر باید گفت خرید از کوچی به دلیل تنوع بالای محصولات، خدمات ارسال سریع، تخفیف‌های ویژه، و امکان خرید آنلاین کالاهای متنوع از برندهای معتبر، یکی از بهترین انتخاب‌ها برای خریداران آنلاین در ایران است. با استفاده از خدمات کوچی، خریدی مطمئن، سریع و راحت را تجربه خواهید کرد.
								</p>

								<p>&nbsp;
								</p>

							</div>
							<span className="inline-flex items-center cursor-pointer styles_Anchor--secondary__3KsgY text-button-2 flex mt-2 items-center user-select-none"><span>مشاهده بیشتر</span>
							<div className="flex">
								<ChevronLeftIcon sx={{width: '18px', height: '18px', fill: 'var(--color-icon-secondary)'}} />
							</div></span>
						</div>
						<div className="w-full flex items-center mt-4 lg:mt-0 justify-center lg:justify-end">
							<a className="cursor-pointer p-2 lg:p-4 flex items-center justify-center border-complete-200 rounded mr-2" target="_blank" href="https://sapra.ir/">
								<div style={{width: '75px', height: '75px', lineHeight: '0'}}>
									<picture>
										<source type="image/webp" srcset={Sapra} />
										<source type="image/jpeg" srcset={Sapra} />
										<img className="w-full inline-block" src={Sapra} width="75" height="75" alt="سامانه پایش مردمی رسانه‌های صوت و تصویر" title="" style={{objectFit: 'contain'}} />
									</picture>
								</div>
							</a>
							<div className="cursor-pointer p-2 lg:p-4 flex items-center justify-center border-complete-200 rounded mr-2">
								<div style={{width: '75px', height: '75px', lineHeight: '0'}}>
									<picture>
										<source type="image/webp" srcset={Rezi} />
										<source type="image/jpeg" srcset={Rezi} />
										<img className="w-full inline-block" src={Rezi} width="75" height="75" alt="نشان ملی ثبت" title="" style={{objectFit: 'contain'}} />
									</picture>
								</div>
							</div>
							<div className="cursor-pointer p-2 lg:p-4 flex items-center justify-center border-complete-200 rounded mr-2">
								<div style={{width: '75px', height: '75px', lineHeight: '0'}}>
									<picture>
										<source type="image/webp" srcset={Kasbokar} />
										<source type="image/jpeg" srcset={Kasbokar} />
										<img className="w-full inline-block" src={Kasbokar} width="75" height="75" alt="نماد کسب و کار های مجازی" title="" style={{objectFit: 'contain'}} />
									</picture>
								</div>
							</div>
							<a className="cursor-pointer p-2 lg:p-4 flex items-center justify-center border-complete-200 rounded mr-2" target="_blank" referrerpolicy="origin" href="https://trustseal.enamad.ir/?id=19077&amp;Code=sScdOJOzhFxtcEqkjP7P">
								<div style={{width: '75px', height: '75px', lineHeight: '0'}}>
									<a
						                href="https://trustseal.enamad.ir/?id=679526&Code=t6XyKO7CVyQmsi0AHBAfyRnUDlEnpQJJ"
						                target="_blank"
						                style={{ display: "flex", alignItems: 'center', justifyContent: 'end' }}
						            >
						                <img
						                    src={Enamad}
						                    alt="Enamad"
						                    style={{ cursor: "pointer", height: '100%', width: 'auto', maxHeight: '136px', display: 'block' }}
						                    code='t6XyKO7CVyQmsi0AHBAfyRnUDlEnpQJJ'
						                />
						            </a>
								</div>
							</a>
						</div>
					</div>
					<div className="flex text-caption text-neutral-500 text-center items-center  justify-center border-complete-t py-8">طراحی توسط  <a href="https://4rk.ir" className="mr-1" title="طراحی اپلیکیشن موبایل | طراحی وبسایت">گروه برنامه نویسی آرک</a>
					</div>
				</div>
			</div>
			<div className="w-full bg-neutral-100 relative z-[999]">
				<div className="container-4xl-w mx-auto flex items-start justify-end flex-wrap">
					<a className="BaseLayoutStaticFooter_BaseLayoutStaticFooter__partnersSectionItem__H4OBR border-complete-r-200 border-complete-b-200 px-5 grow flex flex-col items-center justify-center" data-cro-id="footer-icons" target="_blank" href="https://www.digikala.com/mag/">
						<div style={{height: '20px', lineHeight: '0'}}>
							<span className="w-full inline-block" style={{display: 'inline-block', objectFit: 'contain'}}></span>
						</div>
					</a>
					<a className="BaseLayoutStaticFooter_BaseLayoutStaticFooter__partnersSectionItem__H4OBR border-complete-r-200 border-complete-b-200 px-5 grow flex flex-col items-center justify-center" data-cro-id="footer-icons" target="_blank" href="https://www.mydigipay.com/">
						<div style={{height: '20px', lineHeight: '0'}}>
							<span className="w-full inline-block" style={{display: 'inline-block', objectFit: 'contain'}}></span>
						</div>
					</a>
					<a className="BaseLayoutStaticFooter_BaseLayoutStaticFooter__partnersSectionItem__H4OBR border-complete-r-200 border-complete-b-200 px-5 grow flex flex-col items-center justify-center" data-cro-id="footer-icons" target="_blank" href="https://www.digistyle.com/">
						<div style={{height: '20px', lineHeight: '0'}}>
							<span className="w-full inline-block" style={{display: 'inline-block', objectFit: 'contain'}}></span>
						</div>
					</a>
					<a className="BaseLayoutStaticFooter_BaseLayoutStaticFooter__partnersSectionItem__H4OBR border-complete-r-200 border-complete-b-200 px-5 grow flex flex-col items-center justify-center" data-cro-id="footer-icons" target="_blank" href="/plus/landing/">
						<div style={{height: '20px', lineHeight: '0'}}>
							<span className="w-full inline-block" style={{display: 'inline-block', objectFit: 'contain'}}></span>
						</div>
					</a>
					<a className="BaseLayoutStaticFooter_BaseLayoutStaticFooter__partnersSectionItem__H4OBR border-complete-r-200 border-complete-b-200 px-5 grow flex flex-col items-center justify-center" data-cro-id="footer-icons" target="_blank" href="/digiclub/">
						<div style={{height: '20px', lineHeight: '0'}}>
							<span className="w-full inline-block" style={{display: 'inline-block', objectFit: 'contain'}}></span>
						</div>
					</a>
					<a className="BaseLayoutStaticFooter_BaseLayoutStaticFooter__partnersSectionItem__H4OBR border-complete-r-200 border-complete-b-200 px-5 grow flex flex-col items-center justify-center" data-cro-id="footer-icons" target="_blank" href="https://digikalajet.com/">
						<div style={{height: '20px', lineHeight: '0'}}>
							<span className="w-full inline-block" style={{display: 'inline-block', objectFit: 'contain'}}></span>
						</div>
					</a>
					<a className="BaseLayoutStaticFooter_BaseLayoutStaticFooter__partnersSectionItem__H4OBR border-complete-r-200 border-complete-b-200 px-5 grow flex flex-col items-center justify-center" data-cro-id="footer-icons" target="_blank" href="https://mehr.digikala.com/">
						<div style={{height: '20px', lineHeight: '0'}}>
							<span className="w-full inline-block" style={{display: 'inline-block', objectFit: 'contain'}}></span>
						</div>
					</a>
					<a className="BaseLayoutStaticFooter_BaseLayoutStaticFooter__partnersSectionItem__H4OBR border-complete-r-200 border-complete-b-200 px-5 grow flex flex-col items-center justify-center" data-cro-id="footer-icons" target="_blank" href="https://diginext.ir/">
						<div style={{height: '20px', lineHeight: '0'}}>
							<span className="w-full inline-block" style={{display: 'inline-block', objectFit: 'contain'}}></span>
						</div>
					</a>
					<a className="BaseLayoutStaticFooter_BaseLayoutStaticFooter__partnersSectionItem__H4OBR border-complete-r-200 border-complete-b-200 px-5 grow flex flex-col items-center justify-center" data-cro-id="footer-icons" target="_blank" href="https://digiexpress.ir/">
						<div style={{height: '20px', lineHeight: '0'}}>
							<span className="w-full inline-block" style={{display: 'inline-block', objectFit: 'contain'}}></span>
						</div>
					</a>
					<a className="BaseLayoutStaticFooter_BaseLayoutStaticFooter__partnersSectionItem__H4OBR border-complete-r-200 border-complete-b-200 px-5 grow flex flex-col items-center justify-center" data-cro-id="footer-icons" target="_blank" href="https://ganje.net/?utm_source=Digikala_web&amp;utm_medium=Footer">
						<div style={{height: '20px', lineHeight: '0'}}>
							<span className="w-full inline-block" style={{display: 'inline-block', objectFit: 'contain'}}></span>
						</div>
					</a>
					<a className="BaseLayoutStaticFooter_BaseLayoutStaticFooter__partnersSectionItem__H4OBR border-complete-r-200 border-complete-b-200 px-5 grow flex flex-col items-center justify-center" data-cro-id="footer-icons" target="_blank" href="https://digify.shop/">
						<div style={{height: '20px', lineHeight: '0'}}>
							<span className="w-full inline-block" style={{display: 'inline-block', objectFit: 'contain'}}></span>
						</div>
					</a>
					<a className="BaseLayoutStaticFooter_BaseLayoutStaticFooter__partnersSectionItem__H4OBR border-complete-r-200 border-complete-b-200 px-5 grow flex flex-col items-center justify-center" data-cro-id="footer-icons" target="_blank" href="https://smartech.ir/">
						<div style={{height: '20px', lineHeight: '0'}}>
							<span className="w-full inline-block" style={{display: 'inline-block', objectFit: 'contain'}}></span>
						</div>
					</a>
					<a className="BaseLayoutStaticFooter_BaseLayoutStaticFooter__partnersSectionItem__H4OBR border-complete-r-200 border-complete-b-200 px-5 grow flex flex-col items-center justify-center" data-cro-id="footer-icons" target="_blank" href="https://www.digikalabusiness.com/">
						<div style={{height: '20px', lineHeight: '0'}}>
							<span className="w-full inline-block" style={{display: 'inline-block', objectFit: 'contain'}}></span>
						</div>
					</a>
					<a className="BaseLayoutStaticFooter_BaseLayoutStaticFooter__partnersSectionItem__H4OBR border-complete-r-200 border-complete-b-200 px-5 grow flex flex-col items-center justify-center" data-cro-id="footer-icons" target="_blank" href="https://digikala-service.com/">
						<div style={{height: '20px', lineHeight: '0'}}>
							<span className="w-full inline-block" style={{display: 'inline-block', objectFit: 'contain'}}></span>
						</div>
					</a>
				</div>
			</div>
		</footer>

    );
}

export default FooterBase;
